import React, { PropTypes as T } from 'react';
import { Message, Divider, Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import bowser from 'bowser';
import hasUserInfo from '../../hocs/has-user-info';


import { loadCampaignInvite } from './actions';
import ThemeSelector from '../../themes/theme-selector';

const theme = ThemeSelector.theme();
const CORQ_DOMAIN = 'data.corq.studio';


class CampaignInvite extends React.Component {
  static contextTypes = {
    router: T.object,
  };

  constructor() {
    super();
    this.state = {

    };
  }

  componentDidMount() {
    const { hostname } = window.location;

    const urlInviteId = (this.props.routeParams && this.props.routeParams.inviteid)
      ? this.props.routeParams.inviteid
      : false;

    if (hostname === CORQ_DOMAIN) {
      // TEMPORARILY RE_RUOTE INFLUENCERS TO DYZIO SITE
      window.location = `https://corq.dyzio.co/invite/${urlInviteId}`;
    }

    // if SAFARI cancel the process and ask them to use chrome
    const isBannedBrowser = this.isBannedBrowser();

    if (!isBannedBrowser) {
      this.props.onLoadCampaignInvite({ changeUrlCallback: this.changeUrlPath, urlInviteId });
    } else {
      this.setState({ isBanned: true });
    }
  }

  isBannedBrowser = () => bowser.msie;

  changeUrlPath = path => this.context.router.push(path);

  render() {
    const { error, loading, userInfo } = this.props;

    const is401 = error && error.match(/401/);
    const { isBanned } = this.state;

    const isBannedBrowser = this.isBannedBrowser();
    const url = window.location.href;

    const { email } = userInfo;

    return (
      <div className="page-centered">
        <div className="center-outer">
          { error && !loading &&
            <div className="center-inner">
              <div className="center-logo">
                <a onClick={() => this.context.router.push('/')}>
                  <img src={theme.darkLogo.src} alt={theme.darkLogo.alt} />
                </a>
              </div>
              <div className="center-content">
                <p className="info">There was an error processing your invitation: {error}</p>
                {
                  is401 &&
                  <div>
                    <Divider />
                    <h3 style={{ textAlign: 'center' }}>
                      It looks like you might be testing the invitations...
                      <br />You MUST open the invitation in a DIFFERENT browser!
                    </h3>
                    <Divider />
                    <p style={{ textAlign: 'center' }}>You are currently logged in as {email}</p>
                  </div>
                }
                <br />
                <p className="info"><a onClick={() => this.context.router.push('/')}>continue to the website...</a></p>
              </div>
            </div>
          }

          { !isBanned && loading &&
            <div className="preloader">
              <img src="/icons/dyzio-icon.svg" alt="Loading..." />
            </div>
          }
          {
            isBannedBrowser &&
            <div className="page-centered">
              <div className="center-outer">
                <div className="center-inner">
                  <div className="center-logo">
                    <a href="/"><img src={theme.darkLogo.src} alt={theme.darkLogo.alt} /></a>
                  </div>
                  <div className="center-content">
                    <div className="spacer small" />
                    <h1 style={{ textAlign: 'center' }}>
                    Sorry...<br />We do not support {bowser.name} <Icon name="frown" color="red" />
                    </h1>
                    <div className="spacer" />
                    <h3 className="info" style={{ textAlign: 'center' }}>Please open the invitation in a different browser<br />like Chrome or Firefox.</h3>
                    <hr />
                    <p style={{ textAlign: 'center' }}>{ url }</p>
                    <hr />
                    <p className="info">
                      You can also use the chat button in the bottom right of your screen to contact us directly.
                    </p>
                    <Divider hidden />
                    <Message
                      warning
                      header={'This browser will not work'}
                      content={'Sorry we do not support Safari or IE, please try chrome or firefox. We are working to resolve this!'}
                    />
                  </div>
                </div>
              </div>
            </div>

          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  error: state.invite.get('error'),
  loading: state.invite.get('loading'),
});

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    onLoadCampaignInvite: data => dispatch(loadCampaignInvite(data)),
  };
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  hasUserInfo,
)(CampaignInvite);



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-invite/index.js
 **/